import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './AddProviderRequest.html';
import moment from 'moment';
import AddProviderRequestService from './AddProviderRequestService';
import { Toaster } from '../../Services/toast';
import { AddProviderRequestModel, ProviderRequestAttachmentModel } from './AddProviderRequestModel';
import ValidationService from '../../Services/ValidationService';
import { ProviderAttachmentCategoryType } from '@/shared/Enums/ProviderAttachmentCategoryType';


@WithRender
@Component({
    components: {
    },
    diProvide: [
        AddProviderRequestService,
    ],
})
export default class AddProviderRequest extends Vue {
    @Inject(AddProviderRequestService) public addProviderRequestService!: AddProviderRequestService;
    @Inject(ValidationService) public validationService!: ValidationService;

    public model: AddProviderRequestModel = {
        name: '',
        enterpriseUnifiedNumber: '',
        email: '',
        accreditationNumber: '',
        taxNumber: '',
        username: '',
        useremail: '',
        mobile: '',
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
        expireDate: '',
        ProviderRequestAttachmentModel: []
    };
    public file: ProviderRequestAttachmentModel = {
        fileName: '',
        fileContent: '',
        attachmentType: '',
    };

    public expireDateMenu: boolean = false;
    public username: string = '';
    public email: string = '';
    public mobileNumber: string = '';
    public fileNameDelegationLetter: string = '';

    // reCAPTCHA v3
    private siteKey: string = '';
    private recaptchaLoadPromise: Promise<void> | null = null;
    private recaptchaLoaded: boolean = false;
    private static readonly SENTINEL = 'DEV_BYPASS_TOKEN';

    // OTP state
    public otpDialog: boolean = false;
    public otp: string = '';
    public otpData: string = '';
    public otpExpiresAt: string = '';
    public resendCountDown: number = 0;
    public otpExpiryCountDown: number = 0;
    public otpExpired: boolean = false;
    public otpErrorMessage: string = '';

    public get currentYear() {
        return moment().year();
    }

    public created() {
        const hostname = window.location.hostname;
        const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
        if (isLocal) {
            this.siteKey = '';
        } else {
            this.siteKey = (this.addProviderRequestService.getRecaptchaSiteKey() || '').toString().trim();
            if (this.siteKey) {
                this.recaptchaLoadPromise = this.loadRecaptchaV3(this.siteKey);
            }
        }
    }

    public providerAttachmentCategoryList: Array<{ id: string; name: string }> = [
        { id: ProviderAttachmentCategoryType.CstLicense, name: this.$t('shared.cstLicense').toString() },
        { id: ProviderAttachmentCategoryType.CommercialRegistration, name: this.$t('shared.commercialRegistration').toString() },
        { id: ProviderAttachmentCategoryType.DelegationLetter, name: this.$t('shared.delegationLetter').toString() },
        { id: ProviderAttachmentCategoryType.NationalAddress, name: this.$t('shared.nationalAddress').toString() },
        { id: ProviderAttachmentCategoryType.ZakatTaxCertificate, name: this.$t('shared.zakatTaxCertificate').toString() },
    ];

    public deletedProviderAttachmentCategoryList: Array<{ id: string; name: string }> = [];

    public providerUploadedAttachments: Array<{
        categoryId: string;
        categoryName: string;
        fileName: string;
        fileContent: string;
        fileSize: number;
        fileExt: string;
    }> = [];

    public selectedProviderFileName = '';
    public selectedProviderFileContent = '';
    public selectedProviderFileSize = 0;
    public selectedProviderFileExt = '';
    public selectedProviderAttachmentCategory = '';
    public replaceIndex: number | null = null;
    public providerFileBusy = false;
    public providerFileError = '';
    public providerListError = '';

    private get providerRequiredCategoryIds(): string[] {
        return [
            ProviderAttachmentCategoryType.CstLicense,
            ProviderAttachmentCategoryType.CommercialRegistration,
            ProviderAttachmentCategoryType.DelegationLetter,
            ProviderAttachmentCategoryType.NationalAddress,
            ProviderAttachmentCategoryType.ZakatTaxCertificate,
        ];
    }

    private get hasAllProviderRequiredAttachments(): boolean {
        const uploaded = new Set(this.providerUploadedAttachments.map(a => a.categoryId));
        return this.providerRequiredCategoryIds.every(id => uploaded.has(id));
    }

    public onPickProviderFile() {
        (this.$refs.providerFile as any).value = '';
        (this.$refs.providerFile as any).click();
    }

    public onProviderFilePicked(event: any) {
        const files: FileList = event && event.target && event.target.files;
        if (!files || !files.length) {
            this.resetProviderFileSelection();
            this.replaceIndex = null;
            return;
        }
        if (this.providerFileBusy) return;
        this.providerFileBusy = true;

        try {
            const file = files[0];
            this.selectedProviderFileName = file.name;
            this.selectedProviderFileSize = file.size;
            this.selectedProviderFileExt = (file.name.split('.').pop() || '').toLowerCase();

            const validationMsg = this.validateSelectedFile(this.selectedProviderFileExt, this.selectedProviderFileSize);
            this.providerFileError = validationMsg;
            if (validationMsg) {
                this.selectedProviderFileContent = '';
                this.providerFileBusy = false;
                return;
            }
            const reader = new FileReader();
            reader.onloadend = (e: any) => {
                try {
                    const resultStr = e && e.target && e.target.result ? String(e.target.result) : '';
                    const base64 = resultStr.indexOf(',') >= 0 ? resultStr.split(',')[1] : resultStr;

                    if (typeof this.replaceIndex === 'number' && this.replaceIndex >= 0) {
                        const msg = this.validateSelectedFile(this.selectedProviderFileExt, this.selectedProviderFileSize);
                        this.providerFileError = msg;
                        if (msg) { this.providerFileBusy = false; return; }
                        const existing = this.providerUploadedAttachments[this.replaceIndex];
                        if (existing) {
                            existing.fileName = file.name;
                            existing.fileContent = base64;
                            existing.fileSize = this.selectedProviderFileSize;
                            existing.fileExt = this.selectedProviderFileExt;
                        }
                        this.replaceIndex = null;
                        (this.$refs.providerFile as any).value = '';
                        this.selectedProviderFileName = '';
                        this.selectedProviderFileContent = '';
                        this.selectedProviderFileSize = 0;
                        this.selectedProviderFileExt = '';
                        return;
                    }
                    this.selectedProviderFileContent = base64;
                } finally {
                    this.providerFileBusy = false;
                }
            };
            reader.readAsDataURL(file);
        } catch {
            this.providerFileBusy = false;
            this.resetProviderFileSelection();
            this.replaceIndex = null;
            Toaster.error(this.$t('shared.validationFailed').toString());
        }
    }

    get canAddProviderAttachment(): boolean {
        const hasFile = !!this.selectedProviderFileName && !!this.selectedProviderFileContent;
        const hasCat = !!this.selectedProviderAttachmentCategory;
        const notDup = hasCat && !this.providerUploadedAttachments.some(
            a => a.categoryId === this.selectedProviderAttachmentCategory
        );
        return hasFile && hasCat && notDup;
    }

    public addProviderAttachment() {
        if (this.providerFileError) return; 
        const cat = this.providerAttachmentCategoryList.find(
            c => c.id === this.selectedProviderAttachmentCategory
        );
        if (!cat) {
            Toaster.error(this.$t('shared.addCategory').toString());
            return;
        }

        this.providerUploadedAttachments.push({
            categoryId: cat.id,
            categoryName: cat.name,
            fileName: this.selectedProviderFileName,
            fileContent: this.selectedProviderFileContent,
            fileSize: this.selectedProviderFileSize,
            fileExt: this.selectedProviderFileExt,
        });
        this.deletedProviderAttachmentCategoryList.push(cat);
        const idx = this.providerAttachmentCategoryList.findIndex(x => x.id === cat.id);
        if (idx !== -1) this.providerAttachmentCategoryList.splice(idx, 1);
        this.selectedProviderAttachmentCategory = '';
        this.providerListError = '';
        this.providerFileError = '';
        this.resetProviderFileSelection();
    }

    public deleteProviderAttachment(index: number) {
        const att = this.providerUploadedAttachments[index];
        if (!att) return;
        const deletedCat = this.deletedProviderAttachmentCategoryList.find(d => d.id === att.categoryId);
        if (deletedCat) {
            this.providerAttachmentCategoryList.push(deletedCat);
            const delIdx = this.deletedProviderAttachmentCategoryList.findIndex(d => d.id === att.categoryId);
            if (delIdx !== -1) this.deletedProviderAttachmentCategoryList.splice(delIdx, 1);
        }
        this.providerUploadedAttachments.splice(index, 1);
        this.providerListError = '';
    }

    public replaceProviderAttachment(index: number) {
        if (this.providerFileBusy) return;
        this.replaceIndex = index;
        (this.$refs.providerFile as any).value = '';
        (this.$refs.providerFile as any).click();
    }

    private resetProviderFileSelection() {
        (this.$refs.providerFile as any).value = '';
        this.selectedProviderFileName = '';
        this.selectedProviderFileContent = '';
        this.selectedProviderFileSize = 0;
        this.selectedProviderFileExt = '';
        this.providerFileError = '';
    }

    private validateProviderAttachmentsOnSubmit(): boolean {
        this.providerListError = '';

        if (!this.hasAllProviderRequiredAttachments) {
            this.providerListError = this.$t('shared.attachmentsRequired').toString();
            return false;
        }

        for (let i = 0; i < this.providerUploadedAttachments.length; i++) {
            const a = this.providerUploadedAttachments[i];
            const msg = this.validateSelectedFile((a.fileExt || '').toLowerCase(), a.fileSize);
            if (msg) {
                this.providerListError = msg;
                return false;
            }
        }

        return true;
    }

    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();

        }
    }

    public isMobileNumberValid() {
        if (!this.model.mobile.startsWith('5')) {
            Toaster.error(this.$t('shared.InvalidMobileNumber').toString());
        }
    }

    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }

    }

    public deleteDelegationLetter() {
        const att0 = this.model.ProviderRequestAttachmentModel[0];
        if (att0) {
            att0.fileName = '';
            att0.fileContent = '';
            att0.attachmentType = '';
        }
        this.fileNameDelegationLetter = '';
        (this.$refs.fileDelegationLetter as any).value = '';
    }


    public onPickFile() {
        (this.$refs.fileDelegationLetter as any).click();
    }

    public onFilePicked(event: any) {
        const files: any[] = event.target.files;

        if (this.model.ProviderRequestAttachmentModel.length === 0) {
            this.model.ProviderRequestAttachmentModel.push({
                fileName: '',
                fileContent: '',
                attachmentType: ''
            });
        }

        Array.prototype.forEach.call(files, (file: File) => {
            if (file.size > 3000000) {
                Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
                (this.$refs.fileDelegationLetter as any).value = '';
            } else {
                this.fileNameDelegationLetter = file.name;
                const reader = new FileReader();
                reader.onloadend = (fileData: any) => {
                    this.model.ProviderRequestAttachmentModel[0].fileName = file.name;
                    this.model.ProviderRequestAttachmentModel[0].fileContent =
                        (fileData.target.result as string).split(',')[1] || '';
                };
                reader.readAsDataURL(file);
            }
        });
    }


    public get isValidAddUser(): boolean {
        return (this.username.trim() !== '' &&
            this.email.trim() !== '' &&
            this.validationService.isValidEmail(this.email.trim()) &&
            this.mobileNumber.trim() !== '' &&
            this.mobileNumber.trim().length === 9
        );
    }

    public async addProviderRequest() {
        if (!this.validateProviderAttachmentsOnSubmit()) return;
        this.model.ProviderRequestAttachmentModel = this.providerUploadedAttachments.map(a => ({
            fileName: a.fileName,
            fileContent: a.fileContent,
            attachmentType: a.categoryId,
        }));
        this.model.name = this.model.name.trim();
        this.model.enterpriseUnifiedNumber = this.model.enterpriseUnifiedNumber.trim();
        this.model.accreditationNumber = this.model.accreditationNumber.trim();
        this.model.taxNumber = this.model.taxNumber.trim();
        this.model.email = this.model.email.trim();
        this.model.username = this.model.username.trim();
        this.model.useremail = this.model.useremail.trim();
        this.model.mobile = this.model.mobile.trim();
        this.model.country = this.model.country.trim();
        this.model.city = this.model.city.trim();
        this.model.district = this.model.district.trim();
        this.model.streetName = this.model.streetName.trim();
        this.model.buildingNumber = this.model.buildingNumber.trim();
        this.model.postalCode = this.model.postalCode.trim();
        this.model.vatNumber = this.model.vatNumber.trim();
        this.model.additionalNumber = this.model.additionalNumber.trim();
        this.model.otherIdentifier = this.model.otherIdentifier.trim();

        try {
            const recaptchaToken = await this.getRecaptchaToken('providerRequest');
            const sendOtpResponse = await this.addProviderRequestService.sendOTP({
                email: this.model.email,
                recaptchaToken: recaptchaToken,
                name: this.model.name,
                enterpriseUnifiedNumber: this.model.enterpriseUnifiedNumber,
                accreditationNumber: this.model.accreditationNumber,
                taxNumber: this.model.taxNumber,
                username: this.model.username,
                useremail: this.model.useremail,
            });

            if (sendOtpResponse && sendOtpResponse.isSuccess) {
                this.otpData = sendOtpResponse.data;
                this.otpExpiresAt = sendOtpResponse.expiresAt;
                this.resendCountDown = sendOtpResponse.duration;
                this.otpExpiryCountDown = 300;
                this.otpExpired = false;
                this.otpErrorMessage = '';
                this.otp = '';
                this.otpDialog = true;
                this.startResendCountDown();
                this.startExpiryCountDown();
            } else {
                const msg = sendOtpResponse ? sendOtpResponse.errorMessage : this.$t('shared.errorOccurred').toString();
                Toaster.error(msg);
            }
        } catch (e) {
            Toaster.error(this.$t('shared.errorOccurred').toString());
        }
    }

    public async verifyOTP() {
        if (!this.otp || this.otp.length !== 6) return;

        const response = await this.addProviderRequestService.verifyAndSubmit({
            providerRequest: this.model,
            data: this.otpData,
            otpExpiresAt: this.otpExpiresAt,
            otp: this.otp,
        });

        if (response && response.isSuccess) {
            this.otpDialog = false;
            Toaster.success(this.$t('shared.verificationSuccessful').toString());
            this.$router.push({ name: 'Login' });
        } else {
            const msg = response ? response.errorMessage : this.$t('shared.invalidOTPCode').toString();
            this.otpErrorMessage = msg;
            Toaster.error(msg);
        }
    }

    public async resendOTP() {
        try {
            const recaptchaToken = await this.getRecaptchaToken('providerRequest');
            const sendOtpResponse = await this.addProviderRequestService.sendOTP({
                email: this.model.email,
                recaptchaToken: recaptchaToken,
                name: this.model.name,
                enterpriseUnifiedNumber: this.model.enterpriseUnifiedNumber,
                accreditationNumber: this.model.accreditationNumber,
                taxNumber: this.model.taxNumber,
                username: this.model.username,
                useremail: this.model.useremail,
            });

            if (sendOtpResponse && sendOtpResponse.isSuccess) {
                this.otpData = sendOtpResponse.data;
                this.otpExpiresAt = sendOtpResponse.expiresAt;
                this.resendCountDown = sendOtpResponse.duration;
                this.otpExpiryCountDown = 300;
                this.otpExpired = false;
                this.otpErrorMessage = '';
                this.otp = '';
                this.startResendCountDown();
                this.startExpiryCountDown();
                Toaster.success(this.$t('shared.otpResentSuccessfully').toString());
            } else {
                const msg = sendOtpResponse ? sendOtpResponse.errorMessage : this.$t('shared.errorOccurred').toString();
                Toaster.error(msg);
            }
        } catch (e) {
            Toaster.error(this.$t('shared.errorOccurred').toString());
        }
    }

    public hideOtpDialog() {
        this.otpDialog = false;
        this.otp = '';
        this.resendCountDown = 0;
        this.otpExpiryCountDown = 0;
    }

    public get isResendDisabled(): boolean {
        return this.resendCountDown > 0 && !this.otpExpired;
    }

    private startResendCountDown() {
        if (this.resendCountDown > 0) {
            setTimeout(() => {
                this.resendCountDown -= 1;
                this.startResendCountDown();
            }, 1000);
        }
    }

    private startExpiryCountDown() {
        if (this.otpExpiryCountDown > 0) {
            setTimeout(() => {
                this.otpExpiryCountDown -= 1;
                if (this.otpExpiryCountDown <= 0) {
                    this.otpExpired = true;
                } else {
                    this.startExpiryCountDown();
                }
            }, 1000);
        }
    }

    public get formattedResendCountDown(): string {
        const min = Math.floor(this.resendCountDown / 60);
        const sec = this.resendCountDown % 60;
        return (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
    }

    private containsForbiddenChars(val: string): boolean {
        return val.indexOf('<') >= 0 || val.indexOf('>') >= 0 || val.indexOf('--') >= 0;
    }

    private get hasNoForbiddenChars(): boolean {
        const fields = [
            this.model.name,
            this.model.username,
            this.model.enterpriseUnifiedNumber,
            this.model.taxNumber,
            this.model.country,
            this.model.city,
            this.model.district,
            this.model.streetName,
            this.model.buildingNumber,
            this.model.postalCode,
            this.model.vatNumber,
        ];
        return fields.every(f => !this.containsForbiddenChars(f));
    }

    public get isValid(): boolean {
        const baseOk =
            this.model.name.trim() !== '' &&
            this.model.email.trim() !== '' &&
            this.model.accreditationNumber.trim() !== '' &&
            this.model.taxNumber.trim() !== '' &&
            this.model.enterpriseUnifiedNumber.trim() !== '' &&
            this.model.username.trim() !== '' &&
            this.model.useremail.trim() !== '' &&
            this.model.vatNumber !== '' &&
            this.model.mobile.trim() !== '' &&
            this.model.mobile.startsWith('5') &&
            this.model.mobile.trim().length === 9 &&
            this.model.vatNumber.trim() !== '' &&
            this.model.postalCode.trim() !== '' &&
            this.model.buildingNumber.trim() !== '' &&
            this.model.streetName.trim() !== '' &&
            this.model.district.trim() !== '' &&
            this.model.city.trim() !== '' &&
            this.model.expireDate !== '' &&
            this.model.country.trim() !== '' &&
            this.validationService.isValidEmail(this.model.email.trim()) &&
            this.validationService.isValidEmail(this.model.useremail.trim()) &&
            this.hasNoForbiddenChars;
        return baseOk && this.hasAllProviderRequiredAttachments;
    }

    private validateSelectedFile(ext: string, size: number): string {
        const okType = ext === 'pdf' || ext === 'docx';
        if (!okType) return this.$t('shared.invalidFileType').toString();
        if (size > 3000000) return this.$t('shared.fileSizeExceedsTheLimit').toString();
        return '';
    }

    private async getRecaptchaToken(action: string): Promise<string> {
        const hostname = window.location.hostname;
        const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
        if (isLocal) {
            return AddProviderRequest.SENTINEL;
        }

        if (!this.siteKey || this.siteKey.trim() === '') {
            this.siteKey = (this.addProviderRequestService.getRecaptchaSiteKey() || '').toString().trim();
        }

        if (!this.siteKey) {
            throw new Error('reCAPTCHA site key is empty');
        }

        await (this.recaptchaLoadPromise || this.loadRecaptchaV3(this.siteKey));

        return new Promise((resolve, reject) => {
            const g: any = (window as any).grecaptcha;
            if (!g || !g.ready || !g.execute) {
                reject(new Error('grecaptcha not available after script load'));
                return;
            }
            g.ready(() => {
                g.execute(this.siteKey, { action })
                    .then((token: string) => resolve(token))
                    .catch((e: any) => reject(e));
            });
        });
    }

    private loadRecaptchaV3(siteKey: string): Promise<void> {
        if (this.recaptchaLoaded) {
            return Promise.resolve();
        }

        if (this.recaptchaLoadPromise) {
            return this.recaptchaLoadPromise;
        }

        this.recaptchaLoadPromise = new Promise((resolve, reject) => {
            const w: any = window as any;
            if (w.grecaptcha && w.grecaptcha.execute) {
                this.recaptchaLoaded = true;
                resolve();
                return;
            }

            const existing = document.getElementById('recaptcha-v3') as HTMLScriptElement | null;
            if (existing) {
                existing.onload = () => {
                    this.recaptchaLoaded = true;
                    resolve();
                };
                existing.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
                return;
            }

            const s = document.createElement('script');
            s.id = 'recaptcha-v3';
            s.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
            s.async = true;
            s.defer = true;

            s.onload = () => {
                this.recaptchaLoaded = true;
                resolve();
            };
            s.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));

            document.head.appendChild(s);
        });

        return this.recaptchaLoadPromise;
    }

}